import fetch from "auth/FetchInterceptor";

const userService = {};

userService.getUsers = function () {
  console.log("getUsers");

  return fetch({
    url: `/register/`, // Adjust the endpoint as needed
    method: "GET",
  });
};

userService.createuser = function ({ params, headers }) {
  console.log(params, headers);

  return fetch({
    url: `/users/`,
    method: "POST",
    data: params,
    headers: headers,
  });
};

userService.updateuser = function ({ params, userId }) {
  return fetch({
    url: `/users/${userId}/`,
    method: "PUT",
    data: params,
  });
};

userService.getUserById = function (userId) {
  return fetch({
    url: `/register/${userId}/`, // Adjust the endpoint as needed
    method: "GET",
  });
};

userService.updateuser = function ({ params, userId }) {
  return fetch({
    url: `/register/${userId}/`,
    method: "PUT",
    data: params,
  });
};

userService.setuser = function (data) {
  return fetch({
    url: "/users",
    method: "user",
    data: data,
  });
};

// New method for deleting a user
userService.deleteUser = function (userId) {
  return fetch({
    url: `/register/${userId}/`, // Adjust the endpoint as needed
    method: "delete",
  });
};

userService.getGroup = function () {
  return fetch({
    url: `/groups/`, // Adjust the endpoint as needed
    method: "GET",
  });
};

userService.getGroupById = function (groupId) {
  return fetch({
    url: `/groups/${groupId}/`, // Adjust the endpoint as needed
    method: "GET",
  });
};

userService.createGroup = function (data) {
  return fetch({
    url: `/groups/`,
    method: "POST",
    data: data,
  });
};

userService.updateGroup = function ({ params, groupId }) {
  return fetch({
    url: `/groups/${groupId}/`,
    method: "PUT",
    data: params,
  });
};

userService.deleteGroup = function (groupId) {
  return fetch({
    url: `/groups/${groupId}/`, // Adjust the endpoint as needed
    method: "delete",
  });
};

userService.permissionList = function (groupId) {
  return fetch({
    url: `/permissions?group_id=${groupId}`, // Adjust the endpoint as needed
    method: "GET",
  });
};

userService.createPermission = function (data) {
  return fetch({
    url: `/permissions/create/`,
    method: "POST",
    data: data,
  });
};

userService.deletePermission = function (data) {
  return fetch({
    url: `/permissions/delete/`,
    method: "DELETE",
    data: data,
  });
};

export default userService;
